import React from 'react';
import { Button, Layout, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import MainHeader, { MENU_BOM } from '../components/common/MainHeader';
import { Media } from "../AppMedia";
import { useTranslation } from 'react-i18next';
import BOMList from '../components/bom/BOMList';
import { PATH } from '../routes/Routes';
import { useHistory } from 'react-router-dom';
import ColorButton from '../components/common/ColorButton';

function BOMListView() {
  const history = useHistory();
  const { t } = useTranslation();
  const { Title } = Typography;
  return (
    <div>
      <MainHeader activeItem={MENU_BOM} />

      <Layout>
        <div style={{ margin: '24px', marginTop: '7em' }}>
          <Title level={2}>{t('menus.wood_menus.bom')}</Title>
          <div style={{ textAlign: "right", marginBottom: 12 }}>
            <ColorButton
              positive
              type='primary'
              variant="outlined"
              override="green"
              onClick={() => history.push(`${PATH.BOM}add/`)}>
              <PlusOutlined />
              {t('bom_transactions.add')}
            </ColorButton>
          </div>

          <Media lessThan={"md"}>
            <BOMList />
            {/* <BOMMobileList /> */}
          </Media>

          <Media greaterThanOrEqual="md">
            <BOMList />
          </Media>
        </div>
      </Layout >
    </div >
  );
}

export default BOMListView;